import { DestroyRef, Injectable, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { fromEvent } from "rxjs";

@Injectable({ providedIn: 'root' })
export class PreventBrowserBackButton {
    private destroyRef = inject(DestroyRef);

    register(functionToCall?: () => void) {
        fromEvent(window, 'popstate')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                history.pushState(null, '', location.href);

                if (functionToCall)
                    functionToCall();
            });
    }
}